export default {
  context: {
    user: {},
    tenant: {},
  },
  pages: [],
  themes: [],
  collapsed: false,
  selectedCategory: 'all',
}
